/**
 * Parses date strings in YYYY-MM-DD format for date comparisons.
 * Creates a Date object in local timezone (no timezone conversion needed).
 * Used for comparing dates to determine if events are current/future/past.
 *
 * @param dateString - Date string in YYYY-MM-DD format (e.g., "2025-11-07")
 * @returns Date object, or invalid Date (new Date(NaN)) if parsing fails
 */
export function parseDate(dateString: string): Date {
  // Parse YYYY-MM-DD format directly
  const parts = dateString.split("-");
  if (parts.length === 3) {
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
    const day = parseInt(parts[2], 10);

    // Create date in local timezone (midnight local time)
    const date = new Date(year, month, day);
    if (isNaN(date.getTime())) {
      console.error("Invalid date:", dateString);
      return new Date(NaN);
    }
    return date;
  }
  
  // Fallback to standard parsing
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    console.error("Invalid date:", dateString);
    return new Date(NaN);
  }
  return date;
}
